<template>
  <div id="sixPart">
    <div class="titlePart">
      <h2 class="title">吉美思物联网产业园</h2>
      <div class="intro">
          位于南京市雨花台区中国软件谷核心地段，占地1.8万平方米、建筑面积2.8万平方米，园区入驻数十家企业单位。 
      </div>
    </div>
    <div class="casebutlist">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="imgBox">
      <Viewer :srcArr="srcListArr" />
    </div>

  </div>
</template>

<script>
import Viewer from "../viewer/viewer.vue";
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {
      list: [
        "火灾自动报警系统",
        "电气火灾系统",
        "水系统",
        "视频系统",
        "视频烟火分析系统",
      ],
      srcListArr: [
        {
          src: require("../../assets/img/case/jms.png"),
        },
        {
          src: require("../../assets/img/case/jms2.png"),
        },
      ],
      
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {},
  components: {
    Viewer,
  },
};
</script>

<style scoped lang="scss">
#sixPart {
  padding: 5% 14%;
  .titlePart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      line-height: 4.2rem;
      margin-bottom: 1rem;
    }
    .intro {
      width: 75%;
      color: #999999;
      text-align: justify;
      text-justify: inter-ideograph; /*IE*/
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
  }
  .casebutlist {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 19%;
    margin: 2rem 0;
    .caseButton {
      background: #ffffff;
      color: #00a087;
      padding: 0.5rem 3rem;
      border-radius: 24px;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: 0.15rem;
      margin: 1rem;
      box-shadow: 0px 5px 32px 0px rgba(202, 202, 202, 0.34);
      cursor: pointer;
    }
  }
  .imgBox {
    margin-bottom: 5rem;
    .elRow {
      display: flex;
      flex-wrap: wrap;
    }
    .innerBox {
      position: relative;
      margin-top: 3rem;
      width: 100%;
      height: 30rem;
      display: flex;
      justify-content: space-between;
      .el-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .bigEye {
        position: absolute;
        bottom: 0rem;
        right: 0rem;
        cursor: pointer;
        background: #18b09b;
        width: 3rem;
        height: 3rem;
        border-radius: 0 0 4px 0;
      }
    }
  }

  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../assets/responsive/case.scss";
</style>
